var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoad)?_c('div',{attrs:{"id":"app"}},[(_vm.$route.path === '/login' || _vm.$route.path === '/pricing')?_c('router-view'):_c('container',[_vm._t("default",function(){return [_c('router-view')]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }